import { Context } from "./context";
import { UsersScreen } from "./users";
import { Area01ProductsScreen } from "./area01Products";
import { UnlinkedEansScreen } from "./unlinkedEans";
import { CardInventoryScreen } from "./cardInventory";

export const Admin = Object.assign(Context, {
  UsersScreen,
  Area01ProductsScreen,
  UnlinkedEansScreen,
  CardInventoryScreen,
});
